<template>
  <div class="cmp-product-documents utlz-row">
    <div class="utlz-col-12">
      <ul>
        <li>
          <a class="text-link" @click.prevent="downloadPdf">
            <i class="fa fa-file-text-o"></i>
            <span class="lbl" v-translation="{ code: 'lbl_sds_document', type: 'label'}"></span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        loading: true,
        sdsPdf: []
      }
    },
    computed: {
      ...mapGetters(['language', 'bespokeEndpoints'])
    },
    props: {
      productId: { type: String, required: true }
    },
    methods: {
      async downloadPdf() {
        try {
          const response = await axios.post(`${this.bespokeEndpoints.sdsPdf}`, {
            prodCode: this.productId,
            language: this.language
          },
            {
              responseType: 'blob', // Important to handle binary data
            });

          // Assuming the response data is wrapped in a JSON object with a key 'd'
          const jsonResponse = await response.data.text();
          const parsedResponse = JSON.parse(jsonResponse);
          const pdfData = new Uint8Array(parsedResponse.d);

          const blob = new Blob([pdfData], { type: 'application/pdf' });
          const data = URL.createObjectURL(blob);

          // Open the PDF in a new tab
          var newTab = window.open();
          newTab.document.write(`<iframe src="${data}" width="100%" height="100%"></iframe>`);

          // Create a download link
          var link = document.createElement('a');
          link.href = data;

          const fileName = this.productId + '_' + this.language + '.pdf';
          link.download = fileName;
          link.textContent = 'Download ' + fileName;

          // Style the link to position it at the right end of the page
          link.style.display = 'flex';
          link.style.justifyContent = 'flex-end';
          link.style.margin = '10px';
          link.style.color = '#323639';
          link.style.fontSize = '20px';

          // Append the link to the beginning of the page
          newTab.document.body.insertBefore(link, newTab.document.body.firstChild);

          // Revoke the object URL after some time to free up resources
          setTimeout(() => {
            window.URL.revokeObjectURL(data);
          }, 120000);
        } catch (error) {
          console.error('There was a problem with the axios operation:', error);
        }
      }
    }

  };
</script>

<style>
  /* Add your styles here */
</style>
